export const cleanInputs = () => {
    document.getElementById('user_full_name').value = '';
    document.getElementById('user_password').value = '';
}

export const buildCreateUserBody = (company) => {
    return {
        full_name: document.getElementById('user_full_name').value,
        password: document.getElementById('user_password').value,
        company
    }
}

export const validateUserBody = (body) => {

    if(body.full_name === null || body.full_name === ''){
        throw new Error('Nombre vacío');
    }

    if(body.password === null || body.password === ''){
        throw new Error('Constraseña vacía');
    }
}

export const validateEditUserBody = (body) => {

    if(body.full_name === null || body.full_name === ''){
        throw new Error('Nombre vacío');
    }
}